import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useReducer } from 'react';
import { useInterval } from 'usehooks-ts';
import { getTimeElapsed } from '@marvelapp/core';
import { BtwText } from './BtwText';
import { Stack } from './Stack';
import { cn } from './utils';
export const RecordingIndicator = function RecordingIndicator({ egressStartTime, withBg = false, }) {
    const [_, forceUpdate] = useReducer((c) => c + 1, 0);
    useInterval(forceUpdate, 1000);
    const timeElapsed = egressStartTime ? getTimeElapsed(egressStartTime) : null;
    return (_jsxs(Stack, { align: "center", className: cn({ 'rounded-md bg-gray-950 px-2 py-1': withBg }), direction: "row", gap: "1.5", children: [_jsx("div", { className: cn('relative size-2 rounded-full', {
                    'bg-gray-300': !egressStartTime,
                    'bg-red-500 after:absolute after:inset-0 after:animate-ping after:rounded-full after:bg-red-500 after:content-[""]': !!egressStartTime,
                }) }), _jsx(BtwText, { size: "xs", weight: "medium", variant: withBg ? 'white' : 'primary', children: egressStartTime ? _jsxs(_Fragment, { children: ["Recording (", timeElapsed, ")"] }) : 'Not recording' })] }));
};
